// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.100.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.100.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".grid-stack-item .query-block{max-height:256px}", "",{"version":3,"sources":["webpack://./app/components/home/query/query-block.scss"],"names":[],"mappings":"AAAA,8BAA8B,gBAAgB","sourcesContent":[".grid-stack-item .query-block{max-height:256px}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
